import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/homePage/homePage.vue'
import TokenList from '../views/TokenList/TokenList.vue'
import ShardInformation from '../views/ShardInformation/ShardInformation.vue'
import PartitionSelection from '../views/PartitionSelection/PartitionSelection.vue'
import OnChainQuery from '../views/OnChainQuery/OnChainQuery.vue'
import DevelopmentDocuments from '../views/DevelopmentDocuments/DevelopmentDocuments.vue'
import DocumentDetails from '../views/DevelopmentDocuments/DocumentDetails.vue'

Vue.use(VueRouter)

const routes = [
  //首页
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 代币列表
  {
    path: '/TokenList',
    name: 'TokenList',
    component: TokenList,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 分片信息
  {
    path: '/ShardInformation',
    name: 'ShardInformation',
    component: ShardInformation,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 链上查询
  {
    path: '/OnChainQuery',
    name: 'OnChainQuery',
    component: OnChainQuery,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 最近区块
  {
    path: '/PartitionSelection',
    name: 'PartitionSelection',
    component: PartitionSelection,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 开发文档
  {
    path: '/DevelopmentDocuments',
    name: 'DevelopmentDocuments',
    component: DevelopmentDocuments,
    meta: {
      nave: true,
      foter: true,
    },
  },
  // 文档详情
  {
    path: '/DocumentDetails',
    name: 'DocumentDetails',
    component: DocumentDetails,
    meta: {
      nave: true,
      foter: true,
    },
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
